<template>
  <div :class="classes" @click="$emit('click')">
    <div class="VvBoxItem-Icon">
      <slot />
    </div>

    <div class="VvBoxItem-Title">{{ title }}</div>

    <div class="VvBoxItem-Arrow" v-if="showArrow">
      <arrow-right-icon />
    </div>
  </div>
</template>

<script>
import ArrowRightIcon from '../layout/svg/ArrowRightIcon'

export default {
  name: 'VvBoxItem',
  components: { ArrowRightIcon },
  props: {
    title: String,
    showArrow: {
      type: Boolean,
      default: true
    },
    showBorder: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classes() {
      const classes = ['VvBoxItem-Container']

      if (!this.showBorder) {
        classes.push('no-border')
      }

      return classes.join(' ')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.VvBoxItem-Container {
  cursor: pointer;
  display: flex;
  padding-top: 18px;
  padding-bottom: 18px;
  margin-left: 22px;
  margin-right: 20px;
  border-bottom: 2px solid rgba(220, 220, 220, 0.5);
  align-items: center;
}

.no-border {
  border-bottom: none;
}

.VvBoxItem-Title {
  height: 19px;
  font-size: 14px;
  font-weight: 600;
  font-family: $font-family-home-cards;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-left: 15px;
  margin-top: 5px;
  color: $dark;
  width: 100%;
  text-align: left;
}

.VvBoxItem-Icon {
  height: 20px;
  width: 20px;
}

.VvBoxItem-Arrow {
  float: right;
}
</style>
